import React, { useContext, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { v4 as uuidv4 } from 'uuid';
import { Divider } from 'primereact/divider';
import { formatFromLocalDate } from 'app/shared/util/date-utils';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import DateTextInput from 'app/component/date-text-input';
import { ToastContext } from 'app/context/ToastContext'; //availableAdditionalProductInsurances

const ClientAdditionalInsuranceDialog = ({ clientId, insurances, setInsurances, additionalInsuranceOptions, readOnly }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [editingInsurance, setEditingInsurance] = useState(null);
  const { showSuccess, showError } = useContext(ToastContext);

  const addNewInsurance = () => {
    const newInsurance = {
      tempId: uuidv4(), // Generate a new temporary ID
      productAdditionalInsurance: {},
      insuranceSum: null,
      insuranceBonus: null,
      period: null,
      client: { id: clientId },
      validFrom: null,
      validTo: null,
    };

    setEditingInsurance(newInsurance);
    setVisible(true);
  };

  const deleteInsurance = tempId => {
    const updatedPayments = insurances.filter(payment => payment.tempId !== tempId);
    setInsurances(updatedPayments);
  };

  const editInsurance = oldInsurance => {
    setEditingInsurance(oldInsurance);
    setVisible(true);
  };

  const handleSave = () => {
    if (!editingInsurance.productAdditionalInsurance?.id) {
      showError('Chyba', 'Názov pripoistenia musí byť vybratý');
      return;
    }
    if (!editingInsurance.insuranceSum) {
      showError('Chyba', 'Poistná suma musí byť zadaná.');
      return;
    } else if (editingInsurance.insuranceSum < 0) {
      showError('Chyba', 'Poistná suma nemôže byť záporná.');
      return;
    }
    if (!editingInsurance.insuranceBonus) {
      showError('Chyba', 'Poistné za poistenie musí byť zadané.');
      return;
    } else if (editingInsurance.insuranceBonus < 0) {
      showError('Chyba', 'Poistné za poistenie nemôže byť záporné.');
      return;
    }
    if (!editingInsurance.period) {
      showError('Chyba', 'Poistná doba musí byť zadaná.');
      return;
    } else if (editingInsurance.period < 0) {
      showError('Chyba', 'Poistná doba nemôže byť záporná.');
      return;
    }
    if (!editingInsurance.validFrom) {
      showError('Chyba', 'Dátum platnosti od musí byť zadaný.');
      return;
    }
    if (!editingInsurance.validTo) {
      showError('Chyba', 'Dátum platnosti do musí byť zadaný.');
      return;
    }

    if (editingInsurance.validTo < editingInsurance.validFrom) {
      showError('Chyba', 'Dátum platnosti do nemôže byť pred dátumom platnosti od.');
      return;
    }

    const foundInsurance = insurances.find(i => i.tempId === editingInsurance.tempId);

    if (foundInsurance) {
      setInsurances(insurances.map(i => (i.tempId === editingInsurance.tempId ? editingInsurance : i)));
    } else {
      setInsurances([...insurances, editingInsurance]);
    }

    setEditingInsurance(null);
    setVisible(false);
  };

  const actionBodyTemplate = rowData => {
    return <Button icon="pi pi-trash" disabled={isSaving} className="p-button-danger" onClick={() => deleteInsurance(rowData.tempId)} />;
  };

  let index = 1;

  return (
    <>
      {clientId && (
        <div key="parent-key-id">
          <Divider key="divider-key" align="left" style={{ marginBottom: '1px' }}>
            <div className="inline-flex align-items-center">
              <b>Pripoistenia</b>
              {!readOnly && (
                <Button
                  type="button"
                  onClick={addNewInsurance}
                  label="Pridať"
                  link
                  icon="pi pi-plus"
                  className="p-button-outlined"
                ></Button>
              )}
            </div>
          </Divider>
          {insurances?.map(insurance => {
            return insurance.client?.id === clientId ? (
              <div key={insurance.tempId} style={{ marginTop: '5px' }}>
                <div style={{ fontSize: 18 }}>
                  <b>
                    {index++}. {insurance.productAdditionalInsurance?.name}
                  </b>
                </div>
                <div className="flex justify-content-between" style={{ paddingLeft: '10px', paddingRight: '20px' }}>
                  <div>
                    {'Suma: '} <b>{insurance.insuranceSum}€</b> {' | Poistné: '} <b>{insurance.insuranceBonus} €</b>
                    {' | Doba: '}
                    <b>{insurance.period}</b>
                    {' | '}
                    <i>
                      {formatFromLocalDate(insurance.validFrom)} - {formatFromLocalDate(insurance.validTo)}
                    </i>
                  </div>
                  {!readOnly && (
                    <div>
                      <i
                        className="pi pi-pencil"
                        onClick={() => editInsurance(insurance)}
                        style={{ marginRight: '5px', marginLeft: '5px', cursor: 'pointer', fontSize: '17px', color: 'primary-color' }}
                        aria-hidden="true"
                      />
                      <i
                        className="pi pi-trash"
                        onClick={() => deleteInsurance(insurance.tempId)}
                        style={{ cursor: 'pointer', fontSize: '17px', color: 'red' }}
                        aria-hidden="true"
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <span />
            );
          })}
        </div>
      )}

      <Dialog
        header={'Pripoistenie pre klienta (' + clientId + ')'}
        visible={visible}
        style={{ width: '90vw' }}
        onHide={() => setVisible(false)}
      >
        <div className="p-fluid">
          <div className="grid">
            <div className="col-12">
              <div className="p-field">
                <label htmlFor={`additionalInsurances.${index}.productAdditionalInsurance`}>Názov</label>
                <Dropdown
                  id={`${editingInsurance?.tempId}.productAdditionalInsurance`}
                  name={`${editingInsurance?.tempId}.productAdditionalInsurance`}
                  value={editingInsurance?.productAdditionalInsurance?.id}
                  options={additionalInsuranceOptions}
                  optionLabel="label"
                  onChange={e => {
                    setEditingInsurance({
                      ...editingInsurance,
                      productAdditionalInsurance: { id: e.value, name: additionalInsuranceOptions.find(f => f.value === e.value)?.label },
                    });
                  }}
                  placeholder="Vyberte si pripoistenie"
                />
              </div>
            </div>
            <div className="col-12 md:col-6">
              <div className="p-field">
                <label htmlFor={`${editingInsurance?.tempId}.insuranceSum`}>Poistná suma</label>
                <InputNumber
                  id={`${editingInsurance?.tempId}.insuranceSum`}
                  value={editingInsurance?.insuranceSum}
                  locale="sk"
                  minFractionDigits={0}
                  maxFractionDigits={2}
                  onValueChange={e => {
                    setEditingInsurance({ ...editingInsurance, insuranceSum: e.value });
                  }}
                />
              </div>
            </div>
            {/*Poistne za poistenie*/}
            <div className="col-12 md:col-6">
              <div className="p-field">
                <label htmlFor={`${editingInsurance?.tempId}.insuranceBonus`}>Poistné za poistenie</label>
                <InputNumber
                  id={`${editingInsurance?.tempId}.insuranceBonus`}
                  value={editingInsurance?.insuranceBonus}
                  locale="sk"
                  minFractionDigits={0}
                  maxFractionDigits={2}
                  onValueChange={e => {
                    setEditingInsurance({ ...editingInsurance, insuranceBonus: e.value });
                  }}
                />
              </div>
            </div>
            {/*Doba poistenia*/}
            <div className="col-12 md:col-4">
              <div className="p-field">
                <label htmlFor={`${editingInsurance?.tempId}.period`}>Doba poistenia</label>
                <InputNumber
                  id={`${editingInsurance?.tempId}.period`}
                  value={editingInsurance?.period}
                  locale="sk"
                  onValueChange={e => {
                    setEditingInsurance({ ...editingInsurance, period: e.value });
                  }}
                />
              </div>
            </div>
            <div className="col-12 md:col-4">
              <div className="p-field">
                <label htmlFor={`${editingInsurance?.tempId}.validFrom`}>Platí od</label>
                <DateTextInput
                  id={`${editingInsurance?.tempId}.validFrom`}
                  value={editingInsurance?.validFrom}
                  onChange={val => setEditingInsurance({ ...editingInsurance, validFrom: val })}
                />
              </div>
            </div>
            <div className="col-12 md:col-4">
              <div className="p-field">
                <label htmlFor={`${editingInsurance?.tempId}.validTo`}>Platí do</label>
                <DateTextInput
                  id={`${editingInsurance?.tempId}.validTo`}
                  value={editingInsurance?.validTo}
                  onChange={val => setEditingInsurance({ ...editingInsurance, validTo: val })}
                />
              </div>
            </div>
          </div>
        </div>
        <div style={{ marginTop: '1rem', textAlign: 'right' }}>
          <Button style={{ backgroundColor: '#e31818' }} disabled={isSaving} label="Pridať" icon="pi pi-plus" onClick={handleSave} />
        </div>
      </Dialog>
    </>
  );
};

export default ClientAdditionalInsuranceDialog;
